import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class InfoIcon extends Component {

    render() {
        const {icon, isEnabled, tooltip} = this.props;

        const fontIcon = <FontAwesomeIcon fixedWidth={true} icon={icon} style={(isEnabled) ? {} : {color: '#eaeded'}} />;

        return (isEnabled && tooltip) ?
                    <Popup trigger={fontIcon} content={tooltip} /> :
                    fontIcon;
    }
}

export default InfoIcon;

InfoIcon.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
    isEnabled: PropTypes.bool,
    tooltip: PropTypes.string,
}


// WEBPACK FOOTER //
// ./src/common/InfoIcon.jsx